module.exports = __webpack_public_path__ + "img/enjin.80ff3afc.png";